export const BROADCAST_CHANNEL_NAME = 'reddit_integration_channel';
